var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { SettingsInvoice } from './Model';
export default class default_1 {
    constructor() {
        this.set = (settingsInvoice) => {
            this.settingsInvoice = new SettingsInvoice(settingsInvoice);
        };
        this.push = (settingsInvoice) => {
            this.settingsInvoice = new SettingsInvoice(settingsInvoice);
        };
    }
    read() {
        return api.get('settings/invoice').then(this.set);
    }
    create(settingsInvoice) {
        return api.post('settings/invoice', settingsInvoice).then(this.push);
    }
    update(id, settingsInvoice) {
        return api.put('settings/invoice', settingsInvoice).then(this.set);
    }
}
__decorate([
    observable
], default_1.prototype, "settingsInvoice", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/SettingsInvoice/Store.ts
// module id = 340
// module chunks = 0